export default __webpack_public_path__ + "static/media/history.a7b73d45.svg";